export default "__VITE_ASSET__CLtP_dIF__"